<template>
  <div>
    <div>
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleCreate()">添加</el-button>
      <el-button type="primary" size="mini" icon="el-icon-download" @click="exportJl()">导出</el-button>

      <el-input
        v-model="listQueryJL.name"
        clearable
        placeholder="请输入名称"
        style="width:150px;margin-left:16px"
        size="mini"
      ></el-input>
      <el-button
        type="primary"
        icon="el-icon-search"
        size="mini"
        style="margin-left:16px"
        @click="getJLList()"
      >搜索</el-button>

      <el-button type="primary" size="mini" @click="handleJLUpdate()">编辑</el-button>

      <el-button
        type="danger"
        style="margin-left:16px"
        size="mini"
        @click="handleDelete()"
        icon="el-icon-delete"
      >删除</el-button>
    </div>

    <div style="margin-top:20px">
      <el-table
        ref="JLTable"
        :key="tableKey"
        :data="JLlist"
        border
        height="530px"
        style="width:100%"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" align="center" :selectable="checkboxSelect" width="40"></el-table-column>
        <el-table-column min-width="100px" align="center" :label="'培训班名称'" show-overflow-tooltip prop="name"></el-table-column>
        <el-table-column
          min-width="100px"
          :label="'授课内容'"
          :show-overflow-tooltip="true"
          align="center"
          prop="contents"
        ></el-table-column>

        <el-table-column width="70px" :label="'人数'" align="center" prop="peoplenum"></el-table-column>

        <el-table-column
          width="100px"
          min-height="140px"
          :label="'开始时间'"
          align="center"
          prop="begintime"
        >
          <template slot-scope="scope">
            <span>{{scope.row.begintime.substring(0,10)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="100px"
          min-height="140px"
          :label="'结束时间'"
          align="center"
          prop="endtime"
        >
          <template slot-scope="scope">
            <span>{{scope.row.endtime.substring(0,10)}}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="100px" align="center" :label="'主办单位'" prop="unitname" show-overflow-tooltip></el-table-column>

        <el-table-column width="80px" min-height="140px" :label="'教学测评'" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              :disabled="scope.row.pollid==0"
              @click="appraise(scope.row)"
            >查看结果</el-button>
          </template>
        </el-table-column>

        <el-table-column width="60px" min-height="140px" :label="'来源'" align="center" prop="isseft">
          <template slot-scope="scope">
            <span v-if="scope.row.isseft==0">
              <span>系统</span>
            </span>
            <span v-else-if="scope.row.isseft==1">
              <span>用户</span>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="listQueryJL.page"
        :limit.sync="listQueryJL.limit"
        @pagination="handleCurrentChange"
      />
    </div>

    <el-dialog
      :fullscreen="false"
      class="dialog-mini"
      width="30%"
      title="添加"
      :visible.sync="dialogFormJL"
    >
      <el-form :model="JLform" :rules="JLrules" ref="JLform" label-width="100px">
        <el-form-item size="small" :label="'培训班名称'" prop="name">
          <el-input v-model="JLform.name"></el-input>
        </el-form-item>

        <el-form-item size="small" :label="'主办单位'" prop="unitName">
          <el-input v-model="JLform.unitName"></el-input>
        </el-form-item>

        <el-form-item size="small" :label="'培训人数'" prop="peopleNum">
          <el-input v-model.number="JLform.peopleNum"></el-input>
        </el-form-item>

        <el-form-item size="small" :label="'教学内容'" prop="contents">
          <el-input v-model="JLform.contents" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="cateDicId">
          <elSelectc
            v-if="dialogFormJL"
            :NamespaceId="53"
            :key="sid"
            :typeids="JLform.cateDicId"
            @selectData="selectDatajzDicId"
          ></elSelectc>
        </el-form-item>
        <el-form-item size="small" :label="'开始时间'" prop="beginTime">
          <el-date-picker
            v-model="JLform.beginTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>

        <el-form-item size="small" :label="'结束时间'" prop="endTime">
          <el-date-picker
            v-model="JLform.endTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>

        <div style="text-align:center">
          <el-button size="mini" type="primary" @click="JLsubmit()">确认</el-button>
        </div>
      </el-form>
    </el-dialog>

    <!-- 评价 -->
    <el-dialog
      v-if="submitVisible7"
      width="60%"
      class="dialog-mini"
      :title="'数据分析'"
      :visible.sync="submitVisible7"
      v-model="submitVisible7"
    >
      <statistics ref="statisticschild" :topicId="topicId" @onChange="onChange"></statistics>
    </el-dialog>
  </div>
</template>
<script>
import * as teacherInfo from '@/api/teacher/teacherInfo';
import Pagination from '@/components/Pagination';
import statistics from '@/components/statistics/statistics';
import elSelectc from '@/components/elSelect';
import { getInfo} from '@/utils/auth';
export default {
  components: {
    Pagination,
    statistics,
    elSelectc,
  },
  props: {
    userId: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      sid: +new Date(),
      topicId: 0,
      dialogFormJL: false,
      tableKey: 0,
      total: 0,
      JLlist: [],
      JLform: {
        id: 0,
        userId: this.userId,
        name: '',
        contents: '',
        unitName: '',
        beginTime: '',
        endTime: '',
        createId: null,
        createName:'',
        updateId: 0,
        state: 0,
        cateDicId: null,
        passStatus: 0,
      },
      JLrules: {
        name: [
          { required: true, message: '培训班名称不能为空', trigger: 'blur' },
        ],
        unitName: [
          { required: true, message: '主办单位不能为空', trigger: 'blur' },
        ],
        peopleNum: [
          { required: true, message: '培训人数不能为空', trigger: 'blur' },
        ],
        contents: [
          { required: true, message: '教学内容不能为空', trigger: 'blur' },
        ],
        beginTime: [
          { required: true, message: '开始时间不能为空', trigger: 'blur' },
        ],
        endTime: [
          { required: true, message: '结束时间不能为空', trigger: 'blur' },
        ],
        cateDicId: [
          { required: true, message: '类型不能为空', trigger: 'blur' },
        ],
      },
      listQueryJL: {
        page: 1,
        limit: 10,
        userId: this.userId,
        name: '',
        State: 0,
      },
      multipleSelection: [],
      submitVisible7: false,
      socreName:'',
    };
  },
  computed: {
    getinfo() {
      return this.$store.state.User.infos;
    },
  },
  created() {
      let list = JSON.parse(getInfo('infos'));
      this.socreName=list.name
      this.JLform.createId=list.id
      this.JLform.createName=list.name

    this.getJLList();
  },
  methods: {
    selectDatajzDicId(val) {
      this.JLform.cateDicId = val.value;
    },
    onChange() {
      this.submitVisible7 = false;
    },
    appraise(row) {
      // console.log(row);
      this.topicId = row.pollid;
      this.submitVisible7 = true;
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    checkboxSelect(row, rowIndex) {
      if (row.isseft == 0) {
        return false; // 禁用
      } else {
        return true; // 不禁用
      }
    },
    handleCreate() {
      this.JLform = {
        id: 0,
        userId: this.userId,
        name: '',
        contents: '',
        unitName: '',
        beginTime: '',
        endTime: '',
        createId: JSON.parse(getInfo('infos')).id,
        createName: JSON.parse(getInfo('infos')).name,
        updateId: 0,
        state: 0,
        cateDicId: null,
        passStatus: 0,
      };
      this.dialogFormJL = true;
    },
    JLsubmit() {
      this.$refs['JLform'].validate((vaild) => {
        if (vaild) {
          if (this.JLform.id == 0) {
            this.JLform.userId = this.userId;
            teacherInfo.TeacherCjgzjlAdd(this.JLform).then((res) => {
              this.$notify({
                title: '成功',
                message: '创建成功',
                type: 'success',
                duration: 2000,
              });
              this.dialogFormJL = false;
              this.getJLList();
            });
          } else {
            this.JLform.userId = this.userId;
            this.JLform.updateId = JSON.parse(getInfo('infos')).id;
            teacherInfo.TeacherCjgzjlUpdate(this.JLform).then((res) => {
              this.$notify({
                title: '成功',
                message: '更新成功',
                type: 'success',
                duration: 2000,
              });
              this.dialogFormJL = false;
              this.getJLList();
            });
          }
        }
      });
    },
    exportJl() {
      let that = this;
      let data = {
        page: 1,
        limit: 1000,
        userId: this.userId,
        State: 0,
      };
      teacherInfo.TeacherCjgzjlLoad(data).then((res) => {
        res.data.forEach((element, index) => {
          res.data[index].begintime = element.begintime.slice(0, 10);
          res.data[index].endtime = element.endtime.slice(0, 10);
        });
        let list = res.data;
        require.ensure([], () => {
          const { export_json_to_excel } = require('@/excel/export2Excel'); //这里必须使用绝对路径，使用@/+存放export2Excel的路径
          const tHeader = [
            '培训班名称',
            '授课内容',
            '培训人数',
            '开始时间',
            '结束时间',
            '主办单位',
            '教学测评',
            '数据来源',
          ]; // 导出的表头名信息
          const filterVal = [
            'name',
            'contents',
            'peoplenum',
            'begintime',
            'endtime',
            'unitname',
            'isseft',
          ]; // 导出的表头字段名，需要导出表格字段名

          list.forEach((e) => {
            if (e.isseft === 0) {
              e.isseft = '系统';
            } else {
              e.isseft = '用户';
            }
          });

          const data = that.formatJson(filterVal, list);

          export_json_to_excel(tHeader, data, this.socreName + '教历excel'); // 导出的表格名称，根据需要自己命名
        });
      });
    },
    //格式转换，直接复制即可
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    getJLList() {
      this.listQueryJL.userId = this.userId;
      teacherInfo.TeacherCjgzjlLoad(this.listQueryJL).then((res) => {
        this.JLlist = res.data;
        this.total = res.count;
      });
    },
    handleJLUpdate(row) {
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: '警告',
          message: '请选择一条进行编辑',
          type: 'warning',
          duration: 2000,
        });
        return false;
      }
      if (this.multipleSelection.length > 1) {
        this.$notify({
          title: '警告',
          message: '只能选择一条进行编辑',
          type: 'warning',
          duration: 2000,
        });
        return false;
      }

      //   console.log(row);
      teacherInfo
        .TeacherCjgzjlGet({ id: this.multipleSelection[0].id })
        .then((res) => {
          // this.JLform = res.result;
          this.JLform = Object.assign({}, res.result);
          this.dialogFormJL = true;
        });
    },
    handleDelete() {
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: '警告',
          message: '请选择一条进行删除',
          type: 'warning',
          duration: 2000,
        });
      } else {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          teacherInfo
            .TeacherCjgzjlDelete(this.multipleSelection.map((u) => u.id))
            .then((res) => {
              this.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success',
                duration: 2000,
              });
              this.getJLList();
            });
        });
      }
    },
    handleCurrentChange(val) {
      this.listQueryJL.page = val.page;
      this.listQueryJL.limit = val.limit;
      this.getJLList();
    },
  },
};
</script>